export type AttachmentSelectionMode = "thread" | "reply";

export const THREAD_ATTACHMENT_COUNT = 1;
export const REPLY_ATTACHMENT_MAX_COUNT = 3;
export const ATTACHMENT_VIDEO_MAX_COUNT = 1;

export const THREAD_ATTACHMENT_ERROR =
  "スレッドを立てるには添付ファイルを1個選択してください。";
export const REPLY_ATTACHMENT_COUNT_ERROR =
  "レスに添付できるファイルは3個までです。";
export const ATTACHMENT_VIDEO_COUNT_ERROR =
  "動画は1投稿につき1個まで添付できます。";

export type AttachmentSelectionValidation = {
  valid: boolean;
  error: string | null;
};

export function isVideoFile(file: Pick<File, "type">): boolean {
  return file.type.toLowerCase().startsWith("video/");
}

/** Client-side UX validation. The backend remains authoritative. */
export function validateAttachmentSelection(
  mode: AttachmentSelectionMode,
  files: readonly File[],
): AttachmentSelectionValidation {
  if (mode === "thread" && files.length !== THREAD_ATTACHMENT_COUNT) {
    return { valid: false, error: THREAD_ATTACHMENT_ERROR };
  }
  if (mode === "reply" && files.length > REPLY_ATTACHMENT_MAX_COUNT) {
    return { valid: false, error: REPLY_ATTACHMENT_COUNT_ERROR };
  }
  if (files.filter(isVideoFile).length > ATTACHMENT_VIDEO_MAX_COUNT) {
    return { valid: false, error: ATTACHMENT_VIDEO_COUNT_ERROR };
  }
  return { valid: true, error: null };
}

export function appendAttachmentFiles(
  mode: AttachmentSelectionMode,
  currentFiles: readonly File[],
  addedFiles: readonly File[],
): { files: File[]; error: string | null } {
  const files = [...currentFiles, ...addedFiles];
  const validation = validateAttachmentSelection(mode, files);
  return validation.valid
    ? { files, error: null }
    : { files: [...currentFiles], error: validation.error };
}

export function removeAttachmentFile(
  files: readonly File[],
  index: number,
): File[] {
  return files.filter((_, fileIndex) => fileIndex !== index);
}
